// extracted by mini-css-extract-plugin
export default {"pot":"PotInput_pot__Zh5M+","notch":"PotInput_notch__uKsCE"};